import Script from 'next/script'

export type MSClarityProps = { id: string }

/** MSClarity project: https://clarity.microsoft.com/projects/view/iuho2r7zbp/dashboard?date=Last%203%20days */
export function MSClarity({ id }: MSClarityProps) {
    if (process.env.NEXT_PUBLIC_APP_ENV !== 'production') {
        return null
    }
    const script = `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);
        t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); 
    })(window, document, "clarity", "script", "${id}")`

    return <Script id="ms-clarity" dangerouslySetInnerHTML={{ __html: script }} />
}
